import { Component, computed, inject } from '@angular/core';
import { InlineNotificationComponent } from '../../inline-notification/inline-notification.component';
import { ToastService } from '@mwe/services';
import { Toast } from '@mwe/models';

@Component({
  selector: 'mwe-toast',
  templateUrl: 'toast.component.html',
  imports: [InlineNotificationComponent],
})
export class ToastComponent {
  private readonly toastService = inject(ToastService);

  readonly currentToast = computed<Toast>(() => this.toastService.toast());
}
